import { makeStyles, Typography, Container } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';


let useStyles = makeStyles(() => ({
    homepage: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        left: 0,
        right: 0
    },
    container: {
        marginTop: 100
    }
}));

let Homepage = () => {
    let classes = useStyles();

    return (
        <div className={classes.homepage}>
            <Container
                maxWidth="sm"
                className={classes.container}
            >
                <Typography
                    align="center"
                    variant="h1"
                >
                    Welcome to
                </Typography>

                <Typography align="center">
                    <RouterLink to="/dealers">
                        <img src="/images/logos/Videndum_Media_Solutions_Logo_Black.svg" height={300} />
                    </RouterLink>
                </Typography>

                <Typography
                    align="center"
                    variant="h1"
                >
                    Dealers webapp
                </Typography>
            </Container>
        </div>
    );
}

export default Homepage;